// Enumerations
import { KycMethodsEnumeration } from 'containers/kyc/enumerations/kyc-methods.enumeration';
import { KycStatesEnumeration } from 'containers/kyc/enumerations/kyc-states.enumeration';
// Types
import { KycContextType } from 'containers/kyc/contexts/types/kyc.context.type';
import { KycLandingHandlersUtilsType } from './types/kyc-landing.handlers.utils.type';

const isBizum = (method: KycContextType['selectedMethod']): boolean =>
  method === KycMethodsEnumeration.BIZUM;

const getKycNextStateFromMethod = (
  method: KycContextType['selectedMethod']
): KycStatesEnumeration =>
  isBizum(method) ? KycStatesEnumeration.BIZUM : KycStatesEnumeration.METHOD;

const isVideoCallMethod = (method: KycContextType['selectedMethod']): boolean =>
  method === KycMethodsEnumeration.VIDEOCALL;

const isVideoCallMethodAndNotDeniedPermissions = ({
  method,
  deniedPermissions,
}: KycLandingHandlersUtilsType): boolean =>
  (isVideoCallMethod(method) && !deniedPermissions) || !isVideoCallMethod(method);

export {
  getKycNextStateFromMethod,
  isBizum,
  isVideoCallMethod,
  isVideoCallMethodAndNotDeniedPermissions,
};
